import { motion } from 'framer-motion';
import { forwardRef, ReactNode } from 'react';

type CrossfadePanelProps = {
  children: ReactNode;
  className?: string;
  delay?: number;
  panelKey: string;
  // Opacity-only fade (no Y translate). Use when wrapping table content: a lingering
  // transform on a table makes its 1px row dividers render as visible gray seams.
  translate?: boolean;
};

// Forwards its ref so `AnimatePresence mode="popLayout"` can measure the outgoing panel and lift
// it out of the layout while the next one fades in over it.
export const CrossfadePanel = forwardRef<HTMLDivElement, CrossfadePanelProps>(
  ({ children, className, delay = 0, panelKey, translate = true }, ref) => (
    <motion.div
      animate={translate ? { opacity: 1, y: 0 } : { opacity: 1 }}
      className={className}
      exit={translate ? { opacity: 0, y: -8 } : { opacity: 0 }}
      initial={translate ? { opacity: 0, y: 8 } : { opacity: 0 }}
      key={panelKey}
      ref={ref}
      transition={{ duration: 0.32, ease: 'easeOut', delay }}
    >
      {children}
    </motion.div>
  ),
);

CrossfadePanel.displayName = 'CrossfadePanel';
